// Polish number formatting for form inputs: "1 234,56".
import currency from "currency.js"

function allowOnlyTwoCharactersAfterComa(value) {
  const comma = value.indexOf(",")
  return comma >= 0 ? value.substr(0, comma) + value.substr(comma, 3) : value
}

function allowOnlyNumbersAndComas(value) {
  return value.replace(/[^0-9.,-]/g, "")
}

function replaceDotWithComa(value) {
  return value.replace(/\./g, ",")
}

function groupNumbersByThree(value) {
  const parts = value.toString().split(".")
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ")
  return parts.join(".")
}

// Formatting applied while typing: strips invalid characters, uses a comma as
// the decimal separator, keeps at most two decimals and groups thousands.
export function formatNumberInput(input) {
  let value = input
  value = allowOnlyNumbersAndComas(value)
  value = replaceDotWithComa(value)
  value = allowOnlyTwoCharactersAfterComa(value)
  return groupNumbersByThree(value)
}

// "1 234,56" -> "1234.56"
export function readableToFloat(readable) {
  return readable.replace(/ /g, "").replace(/,/g, ".")
}

// Final formatting when leaving a field: always two decimals ("1 234,50").
export function formatCurrency(value) {
  try {
    return currency(value, { separator: " ", decimal: "," }).format()
  } catch (e) {
    return ""
  }
}

// Product of input values (e.g. quantity × unit price) formatted for an
// input. Empty inputs count as 0.
export function formatProduct(...values) {
  const product = values.reduce((acc, value) => acc * Number(readableToFloat(String(value))), 1)
  return formatNumberInput((isNaN(product) ? 0 : product).toFixed(2))
}
